<div class="kx-ai-container">
  <!-- AI Output Section -->
  <div class="output-section">
    <app-kx-ai-output [config]="outputConfig"></app-kx-ai-output>
  </div>

  <!-- Prompt Input Section -->
  <div class="input-section">
    <form [formGroup]="promptForm" (ngSubmit)="generateResponse()">
      <div class="input-group">
        <textarea
          id="prompt"
          formControlName="prompt"
          placeholder="Type your prompt here..."
          rows="2"
          [class.error]="promptForm.get('prompt')?.invalid && promptForm.get('prompt')?.touched"
        ></textarea>
        <button
          type="submit"
          [disabled]="promptForm.invalid || isLoading"
          class="generate-btn"
          >
          @if (!isLoading) {
            <span>Generate</span>
          }
          @if (isLoading) {
            <span>...</span>
          }
        </button>
      </div>
      @if (promptForm.get('prompt')?.invalid && promptForm.get('prompt')?.touched) {
        <div class="error-message">
          @if (promptForm.get('prompt')?.errors?.['required']) {
            <span>Prompt is required</span>
          }
          @if (promptForm.get('prompt')?.errors?.['minlength']) {
            <span>Prompt must be at least 10 characters</span>
          }
        </div>
      }
    </form>
  </div>
</div>
